// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.savedsearch.HpApiSavedSearchV3Handler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  HpApiSavedSearchV3Handler_create,
  HpApiSavedSearchV3Handler_delete,
  HpApiSavedSearchV3Handler_list,
  HpApiSavedSearchV3Handler_list_Path,
  HpApiSavedSearchV3Handler_update,
} from '@zg-rentals/ts-hotpads-api-client';

import type {
  HpApiResponseDto,
  HpSavedSearchCreateRequestDto,
  HpSavedSearchDto,
  HpSavedSearchListResponseDto,
  HpSavedSearchUpdateRequestDto,
} from '@zg-rentals/ts-hotpads-api-client';

interface DeleteParams {
  searchId: string;
}
interface ListParams {
  page?: number;
  pageSize?: number;
}

export interface HpApiSavedSearchV3Handler_create_Args {
  postData: HpSavedSearchCreateRequestDto;
}

export type HpApiSavedSearchV3Handler_create_Options = UseMutationOptions<
  HpApiResponseDto<HpSavedSearchDto>,
  unknown,
  HpApiSavedSearchV3Handler_create_Args
>;

/**
 * Create a saved search for the authenticated user
 */
export const useHpApiSavedSearchV3Handler_create = ({
  httpClient,
  ...options
}: Omit<HpApiSavedSearchV3Handler_create_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiSavedSearchV3Handler_create_Args) =>
      HpApiSavedSearchV3Handler_create(args.postData, httpClient),
  });
};

export interface HpApiSavedSearchV3Handler_delete_Args {
  getParams: DeleteParams;
}

export type HpApiSavedSearchV3Handler_delete_Options = UseMutationOptions<
  HpApiResponseDto<boolean>,
  unknown,
  HpApiSavedSearchV3Handler_delete_Args
>;

/**
 * Delete a saved search for the authenticated user
 */
export const useHpApiSavedSearchV3Handler_delete = ({
  httpClient,
  ...options
}: Omit<HpApiSavedSearchV3Handler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiSavedSearchV3Handler_delete_Args) =>
      HpApiSavedSearchV3Handler_delete(args.getParams, httpClient),
  });
};

export type HpApiSavedSearchV3Handler_list_Options = UseQueryOptions<
  HpApiResponseDto<HpSavedSearchListResponseDto>,
  unknown,
  HpApiResponseDto<HpSavedSearchListResponseDto>,
  readonly [string, ListParams]
>;

const HpApiSavedSearchV3Handler_list_GetKey = (getParams: ListParams) =>
  [HpApiSavedSearchV3Handler_list_Path, getParams] as const;

export const HpApiSavedSearchV3Handler_list_queryOptions = (
  getParams: ListParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiSavedSearchV3Handler_list_GetKey(getParams),
    queryFn: () => HpApiSavedSearchV3Handler_list(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * List the authenticated user's saved searches
 */
export const useHpApiSavedSearchV3Handler_list = (
  getParams: ListParams,
  {
    httpClient,
    ...options
  }: Omit<HpApiSavedSearchV3Handler_list_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...HpApiSavedSearchV3Handler_list_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useHpApiSavedSearchV3Handler_list.getKey = HpApiSavedSearchV3Handler_list_GetKey;

export interface HpApiSavedSearchV3Handler_update_Args {
  postData: HpSavedSearchUpdateRequestDto;
}

export type HpApiSavedSearchV3Handler_update_Options = UseMutationOptions<
  HpApiResponseDto<HpSavedSearchDto>,
  unknown,
  HpApiSavedSearchV3Handler_update_Args
>;

/**
 * Update an existing saved search for the authenticated user
 */
export const useHpApiSavedSearchV3Handler_update = ({
  httpClient,
  ...options
}: Omit<HpApiSavedSearchV3Handler_update_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiSavedSearchV3Handler_update_Args) =>
      HpApiSavedSearchV3Handler_update(args.postData, httpClient),
  });
};
